export const GENERO = {
    MASCULINO: 1,
    FEMININO: 2,
    OUTRO: 3
}

export function obterGenero(descricao){
    switch(descricao.toLowerCase()){
        case "masculino":
            return GENERO.MASCULINO;
        case "feminino":
            return GENERO.FEMININO;
        default:
            return GENERO.OUTRO;
    }
}


// WEBPACK FOOTER //
// ./src/config/Genero.js